// src/pages/AdminDashboard.js (UPDATED WITH SAMPLES MANAGEMENT LINK)
import React, { useState, useEffect } from 'react';
import {
  Container,
  Grid,
  Paper,
  Typography,
  Box,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Alert,
  Card,
  CardContent,
  IconButton,
  Tooltip,
  Badge,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  CircularProgress,
  TextField,
  Snackbar,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Link,
  Stepper,
  Step,
  StepLabel,
  LinearProgress,
  ListItemIcon,
} from '@mui/material';
import {
  Assignment,
  Person,
  Message,
  Dashboard,
  CheckCircle,
  PendingActions,
  AccessTime,
  Download,
  Visibility,
  Edit,
  Refresh,
  Email,
  AssignmentTurnedIn,
  Work,
  Warning,
  DoneAll,
  PersonOff,
  Cancel,
  List as ListIcon,
  AttachMoney,
  TrendingUp,
  TrendingDown,
  MoreVert,
  Article,
  ExpandMore,
  CloudDownload,
  Description,
  AttachFile,
  CalendarToday,
  School,
  Language,
  FormatSize,
  LineStyle,
  Slideshow,
  Source,
  Payment,
  Star,
  RateReview,
  Schedule,
  Update,
  Create,
  Folder,
  FileCopy,
  Check,
  Close,
  Circle,
  ExpandCircleDown,
  ArrowRightAlt,
  Receipt,
  Timeline,
  AccountCircle,
  CreditCard,
  StarHalf,
  StarBorder,
  StarRate,
  TextSnippet,
  NoteAdd,
  Notes,
  Comment,
  Feedback,
  HourglassEmpty,
  HourglassFull,
  Speed,
  Alarm,
  Timer,
  CalendarMonth,
  Event,
  EventAvailable,
  EventBusy,
  History,
  AccessAlarm,
  Timelapse,
  WatchLater,
  ScheduleSend,
  Send,
  MarkEmailRead,
  Markunread,
  Drafts,
  InsertDriveFile,
  PictureAsPdf,
  Image,
  VideoFile,
  AudioFile,
  Archive,
  FolderOpen,
  FolderShared,
  Cloud,
  CloudQueue,
  CloudDone,
  CloudUpload,
  CloudDownload as CloudDownloadIcon,
  CloudOff,
  Storage,
  Save,
  SaveAlt,
  GetApp,
  FileUpload,
  FileDownload,
  InsertLink,
  Link as LinkIcon,
  Launch,
  OpenInNew,
  OpenInBrowser,
  Preview,
  ZoomIn,
  Search,
  FindInPage,
  Pageview,
  PictureInPicture,
  Crop,
  Filter,
  Sort,
  SwapVert,
  UnfoldMore,
  UnfoldLess,
  KeyboardArrowUp,
  KeyboardArrowDown,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  FirstPage,
  LastPage,
  ChevronLeft,
  ChevronRight,
  NavigateBefore,
  NavigateNext,
  SkipPrevious,
  SkipNext,
  FastForward,
  FastRewind,
  PlayArrow,
  Pause,
  Stop,
  Replay,
  Loop,
  Shuffle,
  Repeat,
  RepeatOne,
  VolumeUp,
  VolumeDown,
  VolumeOff,
  VolumeMute,
  Mic,
  MicOff,
  Videocam,
  VideocamOff,
  CameraAlt,
  Camera,
  PhotoCamera,
  Photo,
  Image as ImageIcon,
  Collections,
  BrokenImage,
  ImageNotSupported,
  NoPhotography,
  CameraFront,
  CameraRear,
  FlipCameraAndroid,
  FlipCameraIos,
  RotateRight,
  RotateLeft,
  Transform,
  CropRotate,
  FilterNone,
  Filter1,
  Filter2,
  Filter3,
  Filter4,
  Filter5,
  Filter6,
  Filter7,
  Filter8,
  Filter9,
  Filter9Plus,
  FilterBAndW,
  FilterCenterFocus,
  FilterDrama,
  FilterFrames,
  FilterHdr,
  FilterNone as FilterNoneIcon,
  FilterTiltShift,
  FilterVintage,
  Gradient,
  Grain,
  GridOff,
  HdrOff,
  HdrOn,
  HdrStrong,
  HdrWeak,
  Healing,
  Looks,
  Looks3,
  Looks4,
  Looks5,
  Looks6,
  LooksOne,
  LooksTwo,
  Loupe,
  MonochromePhotos,
  MusicNote,
  Nature,
  NaturePeople,
  NavigateBefore as NavigateBeforeIcon,
  NavigateNext as NavigateNextIcon,
  Palette,
  PanTool,
  PhotoAlbum,
  PhotoFilter,
  PhotoLibrary,
  PhotoSizeSelectActual,
  PhotoSizeSelectLarge,
  PhotoSizeSelectSmall,
  PictureAsPdf as PictureAsPdfIcon,
  Portrait,
  RawOn,
  ReceiptLong,
  RemoveRedEye,
  Rotate90DegreesCcw,
  ShutterSpeed,
  Square,
  Style,
  SwitchCamera,
  SwitchVideo,
  TagFaces,
  Texture,
  Timelapse as TimelapseIcon,
  Timer10,
  Timer3,
  TimerOff,
  Tonality,
  TouchApp,
  Transform as TransformIcon,
  Tune,
  ViewComfy,
  ViewCompact,
  Vignette,
  WbAuto,
  WbCloudy,
  WbIncandescent,
  WbIridescent,
  WbSunny,
  ZoomOutMap,
  AttachMoney as AttachMoneyIcon,
  LocalOffer,
  Timeline as TimelineIcon,
  Equalizer,
  Settings,
  PriceCheck,
  TrendingUp as TrendingUpIcon,
  Star as StarIcon,
  Science,
  AutoAwesome,
  FileCopy as FileCopyIcon, // Added for samples
} from '@mui/icons-material';
import { 
  getWriters,
  approveWork,
  fetchOrders,
  assignWriterToOrder,
  requestRevision,
  downloadFile,
  downloadOrderFile,
  getOrderFileInfo,
} from '../api/api';
import { format } from 'date-fns';
import './AdminDashboard.css';

// Import components
import MessagingCenter from '../components/messaging/MessagingCenter';
import AdminBlog from './AdminBlog';
import ManageWriters from './managewriters';
import AdminPricingPage from './AdminPricingPage'; // Import the pricing page

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [orders, setOrders] = useState([]);
  const [writers, setWriters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    totalOrders: 0,
    pendingOrders: 0,
    assignedOrders: 0,
    inProgressOrders: 0,
    submittedOrders: 0,
    completedOrders: 0,
    revisionOrders: 0,
    cancelledOrders: 0,
    closedOrders: 0,
    totalWriters: 0,
    activeWriters: 0,
    totalRevenue: 0,
  });

  // Assignment dialog state
  const [assignDialog, setAssignDialog] = useState({
    open: false,
    orderId: null,
    orderTitle: '',
    writerId: '',
    isUnassign: false,
  });

  // Order details dialog state
  const [orderDetails, setOrderDetails] = useState({
    open: false,
    order: null,
  });

  // Revision dialog state
  const [revisionDialog, setRevisionDialog] = useState({
    open: false,
    orderId: null,
    orderTitle: '',
    revisionNotes: '',
  });

  // Snackbar for notifications
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success', // 'success', 'error', 'warning', 'info'
  });

  // Status tabs for orders section
  const statusTabs = [
    { label: 'All', value: 'ALL', icon: <ListIcon /> },
    { label: 'Pending', value: 'PENDING', icon: <PendingActions /> },
    { label: 'Assigned', value: 'ASSIGNED', icon: <Assignment /> },
    { label: 'In Progress', value: 'IN_PROGRESS', icon: <Work /> },
    { label: 'Submitted', value: 'SUBMITTED', icon: <AssignmentTurnedIn /> },
    { label: 'Revision', value: 'REVISION', icon: <Warning /> },
    { label: 'Completed', value: 'COMPLETED', icon: <CheckCircle /> },
    { label: 'Cancelled', value: 'CANCELLED', icon: <Cancel /> },
    { label: 'Closed', value: 'CLOSED', icon: <DoneAll /> },
  ];

  const [activeStatusTab, setActiveStatusTab] = useState(0);

  // UPDATED TABS ARRAY - Added Samples Management next to Pricing Management
  const tabs = [
    { label: 'Dashboard', icon: <Dashboard /> },
    { label: 'Manage Orders', icon: <Assignment /> },
    { label: 'Manage Writers and Payments', icon: <Person /> },
    { label: 'Messages', icon: <Message /> },
    { label: 'Manage Blogs', icon: <Article /> },
    { label: 'Pricing Management', icon: <PriceCheck /> },
    { label: 'Samples Management', icon: <FileCopyIcon />, link: '/dashboard/admin/samples' }, // ADDED SAMPLES TAB
  ];

  // Check user role on mount
  useEffect(() => {
    const checkUserRole = () => {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      console.log("👤 Current user from localStorage:", user);
      
      if (user.role !== 'ADMIN') {
        alert("You need to be logged in as an administrator to access this page.");
      }
    };
    
    checkUserRole();
  }, []);

  // Fetch all data
  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      
      // Fetch orders first
      const ordersResponse = await fetchOrders();
      setOrders(ordersResponse);
      
      // Fetch writers
      try {
        const writersResponse = await getWriters();
        setWriters(writersResponse);
      } catch (writerError) {
        console.error("Failed to fetch writers:", writerError);
        // Use fallback data for testing
        setWriters([
          {
            id: 1,
            username: 'writer1',
            email: 'writer1@gmail.com',
            country: '',
            is_active: true,
            date_joined: new Date().toISOString(),
            assigned_orders_count: 2,
            completed_orders_count: 10,
          },
          {
            id: 2,
            username: 'writer2',
            email: 'writer2@gmail.com',
            country: '',
            is_active: true,
            date_joined: new Date().toISOString(),
            assigned_orders_count: 1,
            completed_orders_count: 5,
          }
        ]);
      }
      
      // Calculate statistics
      calculateStats(ordersResponse, writers);
      
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      showSnackbar('Failed to load dashboard data', 'error');
    } finally {
      setLoading(false);
    }
  };

  const calculateStats = (ordersData, writersData) => {
    const totalOrders = ordersData.length;
    const pendingOrders = ordersData.filter(o => o.status === 'PENDING').length;
    const assignedOrders = ordersData.filter(o => o.status === 'ASSIGNED').length;
    const inProgressOrders = ordersData.filter(o => o.status === 'IN_PROGRESS').length;
    const submittedOrders = ordersData.filter(o => o.status === 'SUBMITTED').length;
    const completedOrders = ordersData.filter(o => o.status === 'COMPLETED').length;
    const revisionOrders = ordersData.filter(o => o.status === 'REVISION').length;
    const cancelledOrders = ordersData.filter(o => o.status === 'CANCELLED').length;
    const closedOrders = ordersData.filter(o => o.status === 'CLOSED').length;
    
    const totalWriters = writersData.length;
    const activeWriters = writersData.filter(w => w.is_active).length;
    
    const totalRevenue = ordersData
      .filter(o => o.status === 'COMPLETED' || o.status === 'CLOSED')
      .reduce((sum, order) => sum + parseFloat(order.budget || 0), 0);
    
    setStats({
      totalOrders,
      pendingOrders,
      assignedOrders,
      inProgressOrders,
      submittedOrders,
      completedOrders,
      revisionOrders,
      cancelledOrders,
      closedOrders,
      totalWriters,
      activeWriters,
      totalRevenue,
    });
  };

  const handleAssignOrder = async () => {
    try {
      if (!assignDialog.writerId) {
        showSnackbar("Please select a writer", 'warning');
        return;
      }
      
      await assignWriterToOrder(assignDialog.orderId, assignDialog.writerId);
      
      // Refresh orders
      const response = await fetchOrders();
      setOrders(response);
      calculateStats(response, writers);
      
      setAssignDialog({ open: false, orderId: null, orderTitle: '', writerId: '', isUnassign: false });
      showSnackbar("Writer assigned successfully!", 'success');
      
    } catch (error) {
      console.error('Error assigning order:', error);
      showSnackbar(`Failed to assign writer: ${error.message}`, 'error');
    }
  };

  const handleUnassignOrder = async (orderId) => {
    try {
      await assignWriterToOrder(orderId, null);
      
      const response = await fetchOrders();
      setOrders(response);
      calculateStats(response, writers);
      showSnackbar("Writer unassigned successfully!", 'success');
      
    } catch (error) {
      console.error('Error unassigning order:', error);
      showSnackbar(`Failed to unassign writer: ${error.message}`, 'error');
    }
  };

  const handleApproveWork = async (orderId) => {
    try {
      console.log(`Approving work for order ${orderId}...`);
      
      // Call the approveWork API function
      const result = await approveWork(orderId);
      
      console.log("Approve result:", result);
      
      // Refresh orders
      const response = await fetchOrders();
      setOrders(response);
      calculateStats(response, writers);
      
      showSnackbar("Work approved successfully! Order status changed to COMPLETED.", 'success');
      
    } catch (error) {
      console.error('Error approving work:', error);
      
      // Provide more specific error messages
      if (error.response?.status === 403) {
        showSnackbar("Permission denied: Only administrators can approve work.", 'error');
      } else if (error.response?.status === 400) {
        const errorMsg = error.response.data?.error || error.message;
        showSnackbar(`Cannot approve: ${errorMsg}`, 'error');
      } else if (error.response?.status === 405) {
        showSnackbar("Server error: Method not allowed. Please check the endpoint configuration.", 'error');
      } else if (error.response?.status === 404) {
        showSnackbar("Order not found or endpoint does not exist.", 'error');
      } else {
        showSnackbar(`Failed to approve work: ${error.message || 'Unknown error'}`, 'error');
      }
    }
  };

  const handleRequestRevision = async () => {
    try {
      if (!revisionDialog.orderId) {
        showSnackbar("No order selected", 'warning');
        return;
      }
      
      await requestRevision(revisionDialog.orderId, revisionDialog.revisionNotes);
      
      // Refresh orders
      const response = await fetchOrders();
      setOrders(response);
      calculateStats(response, writers);
      
      setRevisionDialog({ open: false, orderId: null, orderTitle: '', revisionNotes: '' });
      showSnackbar("Revision requested successfully! The writer has been notified.", 'success');
      
    } catch (error) {
      console.error('Error requesting revision:', error);
      showSnackbar(`Failed to request revision: ${error.message}`, 'error');
    }
  };

  // Enhanced file download handler
  const handleDownloadFile = async (fileUrl, fileName, orderId, fileType) => {
    try {
      console.log(`Downloading ${fileType} for order ${orderId}`);
      
      // If we have orderId and fileType, use the specific download function
      if (orderId && fileType) {
        try {
          const result = await downloadOrderFile(orderId, fileType, fileName);
          showSnackbar(`Downloading ${fileName}...`, 'info');
          return result;
        } catch (specificError) {
          console.log('Specific download failed, trying generic:', specificError);
          // Fall back to generic download
        }
      }
      
      // Use generic download function
      await downloadFile(fileUrl, fileName);
      showSnackbar(`Downloading ${fileName}...`, 'info');
    } catch (error) {
      console.error('Download error:', error);
      
      // Fallback to simple download
      try {
        if (!fileUrl) {
          showSnackbar('No file available to download', 'warning');
          return;
        }

        const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
        const fullUrl = fileUrl.startsWith('http') ? fileUrl : `${baseUrl}${fileUrl}`;
        
        // Add token for authentication
        const token = localStorage.getItem('access_token');
        const urlWithToken = token ? `${fullUrl}?token=${token}` : fullUrl;
        
        // Create and trigger download
        const link = document.createElement('a');
        link.href = urlWithToken;
        link.download = fileName || fileUrl.split('/').pop() || 'download';
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        showSnackbar('Download started in new tab...', 'info');
      } catch (fallbackError) {
        console.error('Fallback download also failed:', fallbackError);
        showSnackbar(`Download failed: ${error.message}`, 'error');
      }
    }
  };

  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  const closeSnackbar = () => {
    setSnackbar({
      ...snackbar,
      open: false,
    });
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'PENDING': return 'warning';
      case 'ASSIGNED': return 'info';
      case 'IN_PROGRESS': return 'primary';
      case 'SUBMITTED': return 'secondary';
      case 'COMPLETED': return 'success';
      case 'REVISION': return 'error';
      case 'CANCELLED': return 'default';
      case 'CLOSED': return 'success';
      default: return 'default';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'PENDING': return <PendingActions />;
      case 'ASSIGNED': return <Assignment />;
      case 'IN_PROGRESS': return <Work />;
      case 'SUBMITTED': return <AssignmentTurnedIn />;
      case 'COMPLETED': return <CheckCircle />;
      case 'REVISION': return <Warning />;
      case 'CANCELLED': return <Cancel />;
      case 'CLOSED': return <DoneAll />;
      default: return <AccessTime />;
    }
  };

  const getStatusClassName = (status) => {
    return status.toLowerCase().replace('_', '-');
  };

  const getTimeRemaining = (deadline) => {
    if (!deadline) return 'No deadline';
    
    const now = new Date();
    const deadlineDate = new Date(deadline);
    const diffMs = deadlineDate - now;
    
    if (diffMs < 0) return 'Overdue';
    
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    
    return `${diffDays}d ${diffHours}h`;
  };

  const getUrgentLevel = (deadline) => {
    if (!deadline) return 'normal';
    
    const now = new Date();
    const deadlineDate = new Date(deadline);
    const diffHours = (deadlineDate - now) / (1000 * 60 * 60);
    
    if (diffHours < 24) return 'critical';
    if (diffHours < 48) return 'high';
    if (diffHours < 72) return 'medium';
    return 'normal';
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      return format(new Date(dateString), 'MMM dd, yyyy HH:mm');
    } catch (error) {
      return 'Invalid date';
    }
  };

  const getFileIcon = (fileName) => {
    if (!fileName) return <InsertDriveFile />;
    
    const ext = fileName.split('.').pop().toLowerCase();
    switch (ext) {
      case 'pdf': return <PictureAsPdf />;
      case 'doc':
      case 'docx': return <Description />;
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif': return <Image />;
      case 'mp4':
      case 'avi':
      case 'mov': return <VideoFile />;
      case 'mp3':
      case 'wav': return <AudioFile />;
      case 'zip':
      case 'rar': return <Archive />;
      default: return <InsertDriveFile />;
    }
  };

  const renderStars = (rating) => {
    if (!rating || rating === 0) return null;
    
    return (
      <Box display="flex" alignItems="center">
        {[...Array(5)].map((_, i) => (
          <Star
            key={i}
            sx={{
              color: i < rating ? '#ffc107' : '#e0e0e0',
              fontSize: '1rem',
            }}
          />
        ))}
        <Typography variant="body2" sx={{ ml: 1, fontWeight: 'bold' }}>
          {rating}/5
        </Typography>
      </Box>
    );
  };

  const getProgressValue = (status) => {
    const progressMap = {
      'PENDING': 10,
      'ASSIGNED': 30,
      'IN_PROGRESS': 60,
      'SUBMITTED': 80,
      'REVISION': 70,
      'COMPLETED': 100,
      'CANCELLED': 0,
      'CLOSED': 100,
    };
    return progressMap[status] || 0;
  };

  // Get filtered orders based on active status tab
  const getFilteredOrders = () => {
    const selectedStatus = statusTabs[activeStatusTab].value;
    
    if (selectedStatus === 'ALL') {
      return orders;
    }
    
    return orders.filter(order => order.status === selectedStatus);
  };

  // Get count for each status tab
  const getStatusCount = (status) => {
    if (status === 'ALL') {
      return orders.length;
    }
    
    return orders.filter(order => order.status === status).length;
  };

  // Handle tab change with navigation for external links
  const handleTabChange = (event, newValue) => {
    const tab = tabs[newValue];
    if (tab.link) {
      // If tab has a link, navigate to it
      window.location.href = tab.link;
    } else {
      // Otherwise just set active tab
      setActiveTab(newValue);
    }
  };

  // Render Dashboard Tab
  const renderDashboard = () => (
    <Box>
      <div className="section-header">
        <Typography variant="h5" className="section-title">
          Dashboard Overview
        </Typography>
        <div className="section-actions">
          <Button
            className="btn btn-outline"
            startIcon={<Refresh />}
            onClick={fetchDashboardData}
          >
            Refresh
          </Button>
        </div>
      </div>
      
      {/* Stats Grid */}
      <div className="stats-grid">
        {/* Total Orders */}
        <Paper className="stat-card" onClick={() => setActiveTab(1)}>
          <div className="stat-card-header">
            <div className="stat-icon primary">
              <Assignment />
            </div>
            <div>
              <Typography variant="subtitle2" className="stat-title">
                Total Orders
              </Typography>
              <Typography variant="h4" className="stat-value">
                {stats.totalOrders}
              </Typography>
              <div className="stat-change positive">
                <TrendingUp fontSize="small" /> +12%
              </div>
            </div>
          </div>
        </Paper>

        {/* Pending Orders */}
        <Paper className="stat-card" onClick={() => { setActiveTab(1); setActiveStatusTab(1); }}>
          <div className="stat-card-header">
            <div className="stat-icon warning">
              <PendingActions />
            </div>
            <div>
              <Typography variant="subtitle2" className="stat-title">
                Pending
              </Typography>
              <Typography variant="h4" className="stat-value">
                {stats.pendingOrders}
              </Typography>
              <div className="stat-change negative">
                <TrendingDown fontSize="small" /> -2%
              </div>
            </div>
          </div>
        </Paper>

        {/* Assigned Orders */}
        <Paper className="stat-card" onClick={() => { setActiveTab(1); setActiveStatusTab(2); }}>
          <div className="stat-card-header">
            <div className="stat-icon info">
              <Assignment />
            </div>
            <div>
              <Typography variant="subtitle2" className="stat-title">
                Assigned
              </Typography>
              <Typography variant="h4" className="stat-value">
                {stats.assignedOrders}
              </Typography>
              <div className="stat-change positive">
                <TrendingUp fontSize="small" /> +5%
              </div>
            </div>
          </div>
        </Paper>

        {/* In Progress Orders */}
        <Paper className="stat-card" onClick={() => { setActiveTab(1); setActiveStatusTab(3); }}>
          <div className="stat-card-header">
            <div className="stat-icon primary">
              <Work />
            </div>
            <div>
              <Typography variant="subtitle2" className="stat-title">
                In Progress
              </Typography>
              <Typography variant="h4" className="stat-value">
                {stats.inProgressOrders}
              </Typography>
              <div className="stat-change positive">
                <TrendingUp fontSize="small" /> +8%
              </div>
            </div>
          </div>
        </Paper>

        {/* Submitted Orders */}
        <Paper className="stat-card" onClick={() => { setActiveTab(1); setActiveStatusTab(4); }}>
          <div className="stat-card-header">
            <div className="stat-icon secondary">
              <AssignmentTurnedIn />
            </div>
            <div>
              <Typography variant="subtitle2" className="stat-title">
                Submitted
              </Typography>
              <Typography variant="h4" className="stat-value">
                {stats.submittedOrders}
              </Typography>
              <div className="stat-change positive">
                <TrendingUp fontSize="small" /> +15%
              </div>
            </div>
          </div>
        </Paper>

        {/* Revision Orders */}
        <Paper className="stat-card" onClick={() => { setActiveTab(1); setActiveStatusTab(5); }}>
          <div className="stat-card-header">
            <div className="stat-icon error">
              <Warning />
            </div>
            <div>
              <Typography variant="subtitle2" className="stat-title">
                Revision
              </Typography>
              <Typography variant="h4" className="stat-value">
                {stats.revisionOrders}
              </Typography>
              <div className="stat-change negative">
                <TrendingDown fontSize="small" /> -3%
              </div>
            </div>
          </div>
        </Paper>

        {/* Completed Orders */}
        <Paper className="stat-card" onClick={() => { setActiveTab(1); setActiveStatusTab(6); }}>
          <div className="stat-card-header">
            <div className="stat-icon success">
              <CheckCircle />
            </div>
            <div>
              <Typography variant="subtitle2" className="stat-title">
                Completed
              </Typography>
              <Typography variant="h4" className="stat-value">
                {stats.completedOrders}
              </Typography>
              <div className="stat-change positive">
                <TrendingUp fontSize="small" /> +20%
              </div>
            </div>
          </div>
        </Paper>

        {/* Total Revenue */}
        <Paper className="stat-card">
          <div className="stat-card-header">
            <div className="stat-icon revenue">
              <AttachMoney />
            </div>
            <div>
              <Typography variant="subtitle2" className="stat-title">
                Total Revenue
              </Typography>
              <Typography variant="h4" className="stat-value">
                ${stats.totalRevenue.toFixed(2)}
              </Typography>
              <div className="stat-change positive">
                <TrendingUp fontSize="small" /> +25%
              </div>
            </div>
          </div>
        </Paper>

        {/* Cancelled Orders */}
        <Paper className="stat-card" onClick={() => { setActiveTab(1); setActiveStatusTab(7); }}>
          <div className="stat-card-header">
            <div className="stat-icon default">
              <Cancel />
            </div>
            <div>
              <Typography variant="subtitle2" className="stat-title">
                Cancelled
              </Typography>
              <Typography variant="h4" className="stat-value">
                {stats.cancelledOrders}
              </Typography>
              <div className="stat-change negative">
                <TrendingDown fontSize="small" /> -1%
              </div>
            </div>
          </div>
        </Paper>

        {/* Closed Orders */}
        <Paper className="stat-card" onClick={() => { setActiveTab(1); setActiveStatusTab(8); }}>
          <div className="stat-card-header">
            <div className="stat-icon success">
              <DoneAll />
            </div>
            <div>
              <Typography variant="subtitle2" className="stat-title">
                Closed
              </Typography>
              <Typography variant="h4" className="stat-value">
                {stats.closedOrders}
              </Typography>
              <div className="stat-change positive">
                <TrendingUp fontSize="small" /> +18%
              </div>
            </div>
          </div>
        </Paper>
      </div>

      {/* Recent Activity */}
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card className="data-table-container">
            <CardContent>
              <div className="section-header">
                <Typography variant="h6" className="section-title">
                  Recent Orders
                </Typography>
                <Button 
                  className="btn btn-outline"
                  size="small"
                  onClick={() => setActiveTab(1)}
                >
                  View All
                </Button>
              </div>
              <TableContainer>
                <Table className="data-table" size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Order ID</TableCell>
                      <TableCell>Title</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Deadline</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {orders.slice(0, 5).map((order) => (
                      <TableRow key={order.id} hover onClick={() => setOrderDetails({ open: true, order })} style={{ cursor: 'pointer' }}>
                        <TableCell>
                          <Typography variant="body2" fontWeight="bold" color="primary">
                            #{order.id}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" noWrap sx={{ maxWidth: 150 }}>
                            {order.title}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Chip
                            className={`status-badge ${getStatusClassName(order.status)}`}
                            icon={getStatusIcon(order.status)}
                            label={order.status}
                            size="small"
                          />
                        </TableCell>
                        <TableCell>
                          <div className={`time-display ${getUrgentLevel(order.deadline)}`}>
                            <AccessTime fontSize="small" />
                            {getTimeRemaining(order.deadline)}
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card className="data-table-container">
            <CardContent>
              <div className="section-header">
                <Typography variant="h6" className="section-title">
                  Writer Performance
                </Typography>
                <Button 
                  className="btn btn-outline"
                  size="small"
                  onClick={() => setActiveTab(2)}
                >
                  View All
                </Button>
              </div>
              <List>
                {writers.slice(0, 5).map((writer) => (
                  <ListItem key={writer.id} className="user-info-cell">
                    <ListItemAvatar>
                      <Avatar className="user-avatar-small">
                        {writer.username?.[0]?.toUpperCase() || 'W'}
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={<Typography className="user-name">{writer.username}</Typography>}
                      secondary={
                        <Typography className="user-email">
                          {writer.assigned_orders_count || 0} assigned orders • {writer.completed_orders_count || 0} completed
                        </Typography>
                      }
                    />
                    <Chip
                      label={writer.is_active ? 'Active' : 'Inactive'}
                      color={writer.is_active ? 'success' : 'default'}
                      size="small"
                      className={writer.is_active ? 'status-badge completed' : 'status-badge pending'}
                    />
                  </ListItem>
                ))}
              </List>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );

  // Render Manage Orders Tab
  const renderManageOrders = () => {
    const filteredOrders = getFilteredOrders();
    const selectedStatus = statusTabs[activeStatusTab].value;
    
    return (
      <Box>
        <div className="section-header">
          <Typography variant="h5" className="section-title">
            Manage Orders
          </Typography>
          <div className="section-actions">
            <Button
              className="btn btn-outline"
              startIcon={<Refresh />}
              onClick={fetchDashboardData}
            >
              Refresh Data
            </Button>
            <Button
              className="btn btn-primary"
              startIcon={<Download />}
            >
              Export
            </Button>
          </div>
        </div>

        {/* Status Tabs for Orders */}
        <Paper className="admin-tabs-container" sx={{ mb: 3 }}>
          <Tabs
            value={activeStatusTab}
            onChange={(e, newValue) => setActiveStatusTab(newValue)}
            className="admin-tabs"
            variant="scrollable"
            scrollButtons="auto"
          >
            {statusTabs.map((tab, index) => (
              <Tab
                key={index}
                icon={tab.icon}
                iconPosition="start"
                label={`${tab.label} (${getStatusCount(tab.value)})`}
                className={`admin-tab ${activeStatusTab === index ? 'active' : ''}`}
              />
            ))}
          </Tabs>
          
          <Box sx={{ p: 2 }}>
            {/* Orders Table */}
            <TableContainer className="data-table-container">
              <Table className="data-table">
                <TableHead>
                  <TableRow>
                    <TableCell>Order ID</TableCell>
                    <TableCell>Title</TableCell>
                    <TableCell>Client</TableCell>
                    <TableCell>Pages</TableCell>
                    <TableCell>Budget</TableCell>
                    <TableCell>Deadline</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Writer</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredOrders.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={9} align="center" sx={{ py: 4 }}>
                        <div className="empty-state">
                          <div className="empty-state-icon">
                            <Assignment fontSize="inherit" />
                          </div>
                          <Typography variant="h6" className="empty-state-title">
                            No orders found
                          </Typography>
                          <Typography variant="body2" className="empty-state-description">
                            {selectedStatus === 'ALL' 
                              ? 'There are no orders in the system yet.'
                              : `No orders with status: ${selectedStatus}`
                            }
                          </Typography>
                          <Button 
                            className="btn btn-primary"
                            onClick={() => setActiveStatusTab(0)}
                          >
                            View All Orders
                          </Button>
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : (
                    filteredOrders.map((order) => (
                      <TableRow key={order.id} hover>
                        <TableCell>
                          <Typography variant="body2" fontWeight="bold" color="primary">
                            #{order.id}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" noWrap sx={{ maxWidth: 200 }}>
                            {order.title}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2">
                            {order.client_username || 'N/A'}
                          </Typography>
                        </TableCell>
                        <TableCell>{order.pages}</TableCell>
                        <TableCell>
                          <Typography variant="body2" fontWeight="bold" className="budget-display">
                            ${parseFloat(order.budget || 0).toFixed(2)}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Box>
                            <Typography variant="body2">
                              {formatDate(order.deadline)}
                            </Typography>
                            <Chip
                              size="small"
                              label={getTimeRemaining(order.deadline)}
                              className={`time-display ${getUrgentLevel(order.deadline)}`}
                              sx={{ mt: 0.5 }}
                            />
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Chip
                            className={`status-badge ${getStatusClassName(order.status)}`}
                            icon={getStatusIcon(order.status)}
                            label={order.status}
                            size="small"
                          />
                          {order.revision_count > 0 && (
                            <Typography variant="caption" color="textSecondary" sx={{ ml: 1 }}>
                              (Rev: {order.revision_count})
                            </Typography>
                          )}
                        </TableCell>
                        <TableCell>
                          {order.writer_username ? (
                            <Chip
                              size="small"
                              label={order.writer_username}
                              className="status-badge assigned"
                              onClick={() => setOrderDetails({ open: true, order })}
                              sx={{ cursor: 'pointer' }}
                            />
                          ) : (
                            <Typography variant="body2" color="textSecondary">
                              Not assigned
                            </Typography>
                          )}
                        </TableCell>
                        <TableCell>
                          <div className="action-buttons">
                            <Tooltip title="View Details">
                              <IconButton
                                className="btn-icon"
                                size="small"
                                onClick={() => setOrderDetails({ open: true, order })}
                              >
                                <Visibility fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            
                            {(order.status === 'PENDING' || (order.status === 'ASSIGNED' && !order.writer_username)) && (
                              <Tooltip title="Assign Writer">
                                <Button
                                  className="btn btn-primary"
                                  size="small"
                                  startIcon={<Person />}
                                  onClick={() => {
                                    setAssignDialog({
                                      open: true,
                                      orderId: order.id,
                                      orderTitle: order.title,
                                      writerId: '',
                                      isUnassign: false,
                                    });
                                  }}
                                >
                                  Assign
                                </Button>
                              </Tooltip>
                            )}
                            
                            {(order.status === 'ASSIGNED' || order.status === 'IN_PROGRESS') && order.writer_username && (
                              <Tooltip title="Unassign Writer">
                                <Button
                                  className="btn btn-warning"
                                  size="small"
                                  startIcon={<Cancel />}
                                  onClick={() => {
                                    if (window.confirm(`Are you sure you want to unassign writer from order #${order.id}?`)) {
                                      handleUnassignOrder(order.id);
                                    }
                                  }}
                                >
                                  Unassign
                                </Button>
                              </Tooltip>
                            )}
                            
                            {order.status === 'SUBMITTED' && (
                              <>
                                <Tooltip title="Approve Work">
                                  <Button
                                    className="btn btn-success"
                                    size="small"
                                    startIcon={<CheckCircle />}
                                    onClick={() => {
                                      if (window.confirm(`Approve work for order #${order.id}? This will mark the order as COMPLETED.`)) {
                                        handleApproveWork(order.id);
                                      }
                                    }}
                                  >
                                    Approve
                                  </Button>
                                </Tooltip>
                                
                                <Tooltip title="Request Revision">
                                  <Button
                                    className="btn btn-warning"
                                    size="small"
                                    startIcon={<Edit />}
                                    onClick={() => {
                                      setRevisionDialog({
                                        open: true,
                                        orderId: order.id,
                                        orderTitle: order.title,
                                        revisionNotes: order.revision_notes || '',
                                      });
                                    }}
                                  >
                                    Request Revision
                                  </Button>
                                </Tooltip>
                              </>
                            )}
                            
                            {order.status === 'REVISION' && (
                              <Tooltip title="View Revision Details">
                                <Button
                                  className="btn btn-outline"
                                  size="small"
                                  startIcon={<Warning />}
                                  onClick={() => setOrderDetails({ open: true, order })}
                                >
                                  View Details
                                </Button>
                              </Tooltip>
                            )}
                            
                            <IconButton className="btn-icon" size="small">
                              <MoreVert fontSize="small" />
                            </IconButton>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Paper>
      </Box>
    );
  };

  // Render Manage Writers and Payments Tab - Loads the ManageWriters component
  const renderManageWritersAndPayments = () => (
    <Box sx={{ width: '100%' }}>
      <ManageWriters />
    </Box>
  );

  // Render Messages Tab - Loads the MessagingCenter component
  const renderMessages = () => (
    <Box sx={{ width: '100%' }}>
      <div className="section-header">
        <Typography variant="h5" className="section-title">
          <Message sx={{ mr: 1 }} /> Messaging Center
        </Typography>
        <div className="section-actions">
          <Button 
            className="btn btn-outline"
            startIcon={<Refresh />}
            onClick={fetchDashboardData}
          >
            Refresh
          </Button>
        </div>
      </div>
      
      {/* Load the complete MessagingCenter component */}
      <Paper className="admin-content-panel messaging-panel">
        <MessagingCenter />
      </Paper>
    </Box>
  );

  // Render Manage Blogs Tab - Loads the AdminBlog component
  const renderManageBlogs = () => (
    <Box sx={{ width: '100%' }}>
      <AdminBlog />
    </Box>
  );

  // Render Pricing Management Tab - Loads the AdminPricingPage component
  const renderPricingManagement = () => (
    <Box sx={{ width: '100%' }}>
      <AdminPricingPage />
    </Box>
  );

  // Render Samples Management Tab - External Link
  const renderSamplesManagement = () => (
    <Box sx={{ width: '100%', textAlign: 'center', py: 8 }}>
      <Paper sx={{ p: 6, borderRadius: 2 }}>
        <FileCopyIcon sx={{ fontSize: 80, color: '#08CB00', mb: 2 }} />
        <Typography variant="h4" gutterBottom sx={{ color: '#333', fontWeight: 600 }}>
          Samples Management
        </Typography>
        <Typography variant="body1" color="textSecondary" sx={{ mb: 4, maxWidth: 600, mx: 'auto' }}>
          Manage essay samples, academic papers, and other writing examples. Create, edit, publish, and organize sample papers for students to browse and download.
        </Typography>
        <Button
          variant="contained"
          size="large"
          startIcon={<Launch />}
          onClick={() => window.open('/dashboard/admin/samples', '_blank')}
          sx={{
            bgcolor: '#08CB00',
            '&:hover': {
              bgcolor: '#07B300',
            },
            px: 4,
            py: 1.5,
            fontSize: '1.1rem',
          }}
        >
          Open Samples Management
        </Button>
        <Typography variant="caption" display="block" sx={{ mt: 2, color: '#999' }}>
          This will open in a new tab: /dashboard/admin/samples
        </Typography>
      </Paper>
    </Box>
  );

  // Enhanced Order Details Dialog with ALL database fields
  const renderOrderDetailsDialog = () => {
    if (!orderDetails.order) return null;
    
    const order = orderDetails.order;
    
    return (
      <Dialog
        open={orderDetails.open}
        onClose={() => setOrderDetails({ ...orderDetails, open: false })}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          className: 'admin-dialog large-dialog'
        }}
      >
        <div className="dialog-header">
          <Typography variant="h6" className="dialog-title">
            <Assignment sx={{ mr: 1 }} />
            Order #{order.id}: {order.title}
          </Typography>
          <IconButton 
            className="dialog-close"
            onClick={() => setOrderDetails({ ...orderDetails, open: false })}
          >
            <Cancel />
          </IconButton>
        </div>
        
        <DialogContent dividers>
          {/* Order Progress Bar */}
          <Box sx={{ mb: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
              <Typography variant="body2" color="text.secondary">
                Order Progress
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {getProgressValue(order.status)}%
              </Typography>
            </Box>
            <LinearProgress 
              variant="determinate" 
              value={getProgressValue(order.status)} 
              sx={{ height: 8, borderRadius: 4 }}
            />
          </Box>
          
          <Grid container spacing={3}>
            {/* Left Column - Order Information */}
            <Grid item xs={12} md={6}>
              {/* Order Status & Basic Info */}
              <Paper className="detail-section" elevation={0} sx={{ p: 2, mb: 2 }}>
                <Typography variant="subtitle1" className="section-title" gutterBottom>
                  <Assignment fontSize="small" sx={{ mr: 1 }} />
                  Order Status & Basic Info
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="body2" className="detail-label">Status:</Typography>
                    <Chip
                      className={`status-badge ${getStatusClassName(order.status)}`}
                      icon={getStatusIcon(order.status)}
                      label={order.status}
                      sx={{ mt: 0.5 }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" className="detail-label">Revision Count:</Typography>
                    <Typography variant="body1" sx={{ mt: 0.5 }}>
                      {order.revision_count || 0}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" className="detail-label">Order ID:</Typography>
                    <Typography variant="body1" fontWeight="bold" sx={{ mt: 0.5 }}>
                      #{order.id}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" className="detail-label">Budget:</Typography>
                    <Typography variant="body1" fontWeight="bold" color="primary" sx={{ mt: 0.5 }}>
                      ${parseFloat(order.budget || 0).toFixed(2)}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>

              {/* Client Information */}
              <Paper className="detail-section" elevation={0} sx={{ p: 2, mb: 2 }}>
                <Typography variant="subtitle1" className="section-title" gutterBottom>
                  <AccountCircle fontSize="small" sx={{ mr: 1 }} />
                  Client Information
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="body2" className="detail-label">Client Name:</Typography>
                    <Typography variant="body1" sx={{ mt: 0.5 }}>
                      {order.client_username || 'N/A'}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body2" className="detail-label">Client Email:</Typography>
                    <Typography variant="body1" sx={{ mt: 0.5 }}>
                      {order.client_email || 'N/A'}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>

              {/* Writer Information */}
              <Paper className="detail-section" elevation={0} sx={{ p: 2, mb: 2 }}>
                <Typography variant="subtitle1" className="section-title" gutterBottom>
                  <Person fontSize="small" sx={{ mr: 1 }} />
                  Writer Information
                </Typography>
                {order.writer_username ? (
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Typography variant="body2" className="detail-label">Assigned Writer:</Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
                        <Avatar sx={{ width: 32, height: 32, mr: 1 }}>
                          {order.writer_username?.[0]?.toUpperCase() || 'W'}
                        </Avatar>
                        <Box>
                          <Typography variant="body1">{order.writer_username}</Typography>
                          <Typography variant="body2" color="textSecondary">
                            {order.writer_email || 'N/A'}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                    {order.submitted_at && (
                      <Grid item xs={12}>
                        <Typography variant="body2" className="detail-label">Submitted At:</Typography>
                        <Typography variant="body2" sx={{ mt: 0.5 }}>
                          {formatDate(order.submitted_at)}
                        </Typography>
                      </Grid>
                    )}
                  </Grid>
                ) : (
                  <Typography variant="body2" color="textSecondary">
                    No writer assigned yet
                  </Typography>
                )}
              </Paper>

              {/* Order Specifications */}
              <Paper className="detail-section" elevation={0} sx={{ p: 2, mb: 2 }}>
                <Typography variant="subtitle1" className="section-title" gutterBottom>
                  <Description fontSize="small" sx={{ mr: 1 }} />
                  Order Specifications
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="body2" className="detail-label">Subject:</Typography>
                    <Typography variant="body1" sx={{ mt: 0.5 }}>
                      {order.subject || 'N/A'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" className="detail-label">Academic Level:</Typography>
                    <Typography variant="body1" sx={{ mt: 0.5 }}>
                      {order.academic_level || 'N/A'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" className="detail-label">Pages:</Typography>
                    <Typography variant="body1" sx={{ mt: 0.5 }}>
                      {order.pages}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" className="detail-label">Word Count (est.):</Typography>
                    <Typography variant="body1" sx={{ mt: 0.5 }}>
                      {(order.pages || 0) * 275} words
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" className="detail-label">Language:</Typography>
                    <Typography variant="body1" sx={{ mt: 0.5 }}>
                      {order.language || 'English'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" className="detail-label">Format:</Typography>
                    <Typography variant="body1" sx={{ mt: 0.5 }}>
                      {order.format || 'APA'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" className="detail-label">Spacing:</Typography>
                    <Typography variant="body1" sx={{ mt: 0.5 }}>
                      {order.spacing || 'Double'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" className="detail-label">Slides:</Typography>
                    <Typography variant="body1" sx={{ mt: 0.5 }}>
                      {order.slides || 0}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" className="detail-label">Sources:</Typography>
                    <Typography variant="body1" sx={{ mt: 0.5 }}>
                      {order.sources || 0}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>

            {/* Right Column - Timelines & Files */}
            <Grid item xs={12} md={6}>
              {/* Timelines */}
              <Paper className="detail-section" elevation={0} sx={{ p: 2, mb: 2 }}>
                <Typography variant="subtitle1" className="section-title" gutterBottom>
                  <Schedule fontSize="small" sx={{ mr: 1 }} />
                  Timelines
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="body2" className="detail-label">Created At:</Typography>
                    <Typography variant="body2" sx={{ mt: 0.5 }}>
                      {formatDate(order.created_at)}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" className="detail-label">Last Updated:</Typography>
                    <Typography variant="body2" sx={{ mt: 0.5 }}>
                      {formatDate(order.updated_at)}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body2" className="detail-label">Deadline:</Typography>
                    <Box sx={{ mt: 0.5 }}>
                      <Typography variant="body2">
                        {formatDate(order.deadline)}
                      </Typography>
                      <Chip
                        size="small"
                        label={getTimeRemaining(order.deadline)}
                        className={`time-display ${getUrgentLevel(order.deadline)}`}
                        sx={{ mt: 0.5 }}
                      />
                    </Box>
                  </Grid>
                  {order.completed_at && (
                    <Grid item xs={6}>
                      <Typography variant="body2" className="detail-label">Completed At:</Typography>
                      <Typography variant="body2" sx={{ mt: 0.5 }}>
                        {formatDate(order.completed_at)}
                      </Typography>
                    </Grid>
                  )}
                  {order.revision_requested_at && (
                    <Grid item xs={6}>
                      <Typography variant="body2" className="detail-label">Revision Requested:</Typography>
                      <Typography variant="body2" sx={{ mt: 0.5 }}>
                        {formatDate(order.revision_requested_at)}
                      </Typography>
                    </Grid>
                  )}
                  {order.rated_at && (
                    <Grid item xs={6}>
                      <Typography variant="body2" className="detail-label">Rated At:</Typography>
                      <Typography variant="body2" sx={{ mt: 0.5 }}>
                        {formatDate(order.rated_at)}
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </Paper>

              {/* Additional Services */}
              <Paper className="detail-section" elevation={0} sx={{ p: 2, mb: 2 }}>
                <Typography variant="subtitle1" className="section-title" gutterBottom>
                  <AttachMoney fontSize="small" sx={{ mr: 1 }} />
                  Additional Services
                </Typography>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <Chip
                      size="small"
                      icon={order.plagiarism_report ? <Check /> : <Close />}
                      label="Plagiarism Report"
                      color={order.plagiarism_report ? "success" : "default"}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Chip
                      size="small"
                      icon={order.executive_summary ? <Check /> : <Close />}
                      label="Executive Summary"
                      color={order.executive_summary ? "success" : "default"}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Chip
                      size="small"
                      icon={order.expert_writer ? <Check /> : <Close />}
                      label="Expert Writer"
                      color={order.expert_writer ? "success" : "default"}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              </Paper>

              {/* Files Section */}
              <Paper className="detail-section" elevation={0} sx={{ p: 2, mb: 2 }}>
                <Typography variant="subtitle1" className="section-title" gutterBottom>
                  <Folder fontSize="small" sx={{ mr: 1 }} />
                  Files & Attachments
                </Typography>
                
                {/* Client Uploaded Files */}
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" fontWeight="medium" gutterBottom>
                    <AttachFile fontSize="small" sx={{ mr: 1, verticalAlign: 'middle' }} />
                    Client Uploaded Files:
                  </Typography>
                  {order.files ? (
                    <Button
                      className="btn btn-outline"
                      startIcon={getFileIcon(order.files)}
                      fullWidth
                      onClick={() => handleDownloadFile(
                        order.files, 
                        `order_${order.id}_client_files`,
                        order.id,
                        'client_files'
                      )}
                      sx={{ justifyContent: 'flex-start' }}
                    >
                      Download Client Files
                    </Button>
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      No files uploaded by client
                    </Typography>
                  )}
                </Box>
                
                {/* Writer Submitted Work */}
                <Box>
                  <Typography variant="body2" fontWeight="medium" gutterBottom>
                    <FileCopy fontSize="small" sx={{ mr: 1, verticalAlign: 'middle' }} />
                    Writer Submitted Work:
                  </Typography>
                  {order.completed_work ? (
                    <Button
                      className="btn btn-primary"
                      startIcon={<CloudDownload />}
                      fullWidth
                      onClick={() => handleDownloadFile(
                        order.completed_work, 
                        `order_${order.id}_completed_work`,
                        order.id,
                        'completed_work'
                      )}
                      sx={{ justifyContent: 'flex-start' }}
                    >
                      Download Completed Work
                    </Button>
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      No work submitted by writer yet
                    </Typography>
                  )}
                </Box>
              </Paper>

              {/* Rating & Review */}
              {order.rating && (
                <Paper className="detail-section" elevation={0} sx={{ p: 2, mb: 2 }}>
                  <Typography variant="subtitle1" className="section-title" gutterBottom>
                    <Star fontSize="small" sx={{ mr: 1 }} />
                    Client Rating & Review
                  </Typography>
                  <Box>
                    <Typography variant="body2" className="detail-label" gutterBottom>
                      Rating:
                    </Typography>
                    {renderStars(order.rating)}
                    {order.client_review && (
                      <>
                        <Typography variant="body2" className="detail-label" sx={{ mt: 2 }} gutterBottom>
                          Review:
                        </Typography>
                        <Paper variant="outlined" sx={{ p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
                          <Typography variant="body2">
                            {order.client_review}
                          </Typography>
                        </Paper>
                      </>
                    )}
                  </Box>
                </Paper>
              )}
            </Grid>

            {/* Full Width Sections */}
            <Grid item xs={12}>
              {/* Instructions */}
              <Paper className="detail-section" elevation={0} sx={{ p: 2, mb: 2 }}>
                <Typography variant="subtitle1" className="section-title" gutterBottom>
                  <Notes fontSize="small" sx={{ mr: 1 }} />
                  Instructions
                </Typography>
                <Paper variant="outlined" sx={{ p: 2, bgcolor: 'grey.50', borderRadius: 1, minHeight: 100 }}>
                  <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                    {order.instructions || 'No instructions provided'}
                  </Typography>
                </Paper>
              </Paper>
            </Grid>

            {/* Writer Notes */}
            {order.writer_notes && (
              <Grid item xs={12}>
                <Paper className="detail-section" elevation={0} sx={{ p: 2, mb: 2 }}>
                  <Typography variant="subtitle1" className="section-title" gutterBottom>
                    <Comment fontSize="small" sx={{ mr: 1 }} />
                    Writer's Notes
                  </Typography>
                  <Paper variant="outlined" sx={{ p: 2, bgcolor: 'info.light', borderRadius: 1 }}>
                    <Typography variant="body2">
                      {order.writer_notes}
                    </Typography>
                  </Paper>
                </Paper>
              </Grid>
            )}

            {/* Revision Notes */}
            {order.revision_notes && (
              <Grid item xs={12}>
                <Paper className="detail-section" elevation={0} sx={{ p: 2, mb: 2 }}>
                  <Typography variant="subtitle1" className="section-title" gutterBottom>
                    <Feedback fontSize="small" sx={{ mr: 1 }} />
                    Revision Notes
                  </Typography>
                  <Paper variant="outlined" sx={{ p: 2, bgcolor: 'warning.light', borderRadius: 1 }}>
                    <Typography variant="body2" color="warning.dark">
                      {order.revision_notes}
                    </Typography>
                  </Paper>
                </Paper>
              </Grid>
            )}

            {/* Price Breakdown */}
            {order.price_breakdown && Object.keys(order.price_breakdown).length > 0 && (
              <Grid item xs={12}>
                <Paper className="detail-section" elevation={0} sx={{ p: 2, mb: 2 }}>
                  <Typography variant="subtitle1" className="section-title" gutterBottom>
                    <Receipt fontSize="small" sx={{ mr: 1 }} />
                    Price Breakdown
                  </Typography>
                  <Paper variant="outlined" sx={{ p: 2, borderRadius: 1 }}>
                    <Grid container spacing={2}>
                      {Object.entries(order.price_breakdown).map(([key, value]) => (
                        <Grid item xs={6} sm={4} key={key}>
                          <Typography variant="body2" color="textSecondary">
                            {key.replace(/_/g, ' ').toUpperCase()}:
                          </Typography>
                          <Typography variant="body1" fontWeight="medium">
                            ${parseFloat(value).toFixed(2)}
                          </Typography>
                        </Grid>
                      ))}
                    </Grid>
                  </Paper>
                </Paper>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        
        <div className="dialog-footer">
          <Button 
            className="btn btn-outline"
            onClick={() => setOrderDetails({ ...orderDetails, open: false })}
          >
            Close
          </Button>
          {order.status === 'PENDING' && (
            <Button
              className="btn btn-primary"
              onClick={() => {
                setOrderDetails({ ...orderDetails, open: false });
                setTimeout(() => {
                  setAssignDialog({
                    open: true,
                    orderId: order.id,
                    orderTitle: order.title,
                    writerId: '',
                    isUnassign: false,
                  });
                }, 100);
              }}
            >
              Assign Writer
            </Button>
          )}
          {(order.status === 'ASSIGNED' || order.status === 'IN_PROGRESS') && order.writer_username && (
            <Button
              className="btn btn-warning"
              onClick={() => {
                if (window.confirm(`Unassign writer from order #${order.id}?`)) {
                  handleUnassignOrder(order.id);
                  setOrderDetails({ ...orderDetails, open: false });
                }
              }}
            >
              Unassign Writer
            </Button>
          )}
          {order.status === 'SUBMITTED' && (
            <>
              <Button
                className="btn btn-success"
                onClick={() => {
                  if (window.confirm(`Approve work for order #${order.id}? This will mark the order as COMPLETED.`)) {
                    handleApproveWork(order.id);
                    setOrderDetails({ ...orderDetails, open: false });
                  }
                }}
              >
                Approve Work
              </Button>
              <Button
                className="btn btn-warning"
                onClick={() => {
                  setOrderDetails({ ...orderDetails, open: false });
                  setTimeout(() => {
                    setRevisionDialog({
                      open: true,
                      orderId: order.id,
                      orderTitle: order.title,
                      revisionNotes: order.revision_notes || '',
                    });
                  }, 100);
                }}
              >
                Request Revision
              </Button>
            </>
          )}
        </div>
      </Dialog>
    );
  };

  // Assignment Dialog
  const renderAssignDialog = () => (
    <Dialog
      open={assignDialog.open}
      onClose={() => setAssignDialog({ ...assignDialog, open: false })}
      PaperProps={{
        className: 'admin-dialog'
      }}
    >
      <div className="dialog-header">
        <Typography variant="h6" className="dialog-title">
          <Assignment /> Assign Order #{assignDialog.orderId}
        </Typography>
        <IconButton 
          className="dialog-close"
          onClick={() => setAssignDialog({ ...assignDialog, open: false })}
        >
          <Cancel />
        </IconButton>
      </div>
      
      <DialogContent>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          {assignDialog.orderTitle}
        </Typography>
        
        <div className="form-group">
          <Typography className="form-label">Select Writer</Typography>
          <FormControl fullWidth>
            <Select
              value={assignDialog.writerId}
              onChange={(e) => setAssignDialog({ ...assignDialog, writerId: e.target.value })}
              displayEmpty
              className="select-control"
            >
              <MenuItem value="">
                <em>Select a writer</em>
              </MenuItem>
              {writers.length === 0 ? (
                <MenuItem disabled>
                  No writers available in database
                </MenuItem>
              ) : (
                writers
                  .filter(writer => writer.is_active)
                  .map((writer) => (
                    <MenuItem key={writer.id} value={writer.id}>
                      <div className="user-info-cell">
                        <Avatar sx={{ width: 24, height: 24, fontSize: 14 }}>
                          {writer.username?.[0]?.toUpperCase() || 'W'}
                        </Avatar>
                        <Box>
                          <Typography variant="body2">{writer.username}</Typography>
                          <Typography variant="caption" color="textSecondary">
                            {writer.email} • {writer.assigned_orders_count || 0} assigned
                          </Typography>
                        </Box>
                      </div>
                    </MenuItem>
                  ))
              )}
            </Select>
          </FormControl>
        </div>
        
        {writers.filter(w => w.is_active).length === 0 && (
          <Alert severity="warning" className="alert alert-warning">
            <Typography variant="body2">
              No active writers available. Please activate writers first.
            </Typography>
          </Alert>
        )}
      </DialogContent>
      
      <div className="dialog-footer">
        <Button 
          className="btn btn-outline"
          onClick={() => setAssignDialog({ ...assignDialog, open: false })}
        >
          Cancel
        </Button>
        <Button 
          className="btn btn-primary"
          onClick={handleAssignOrder}
          disabled={!assignDialog.writerId || writers.filter(w => w.is_active).length === 0}
        >
          Assign Order
        </Button>
      </div>
    </Dialog>
  );

  // Revision Dialog
  const renderRevisionDialog = () => (
    <Dialog
      open={revisionDialog.open}
      onClose={() => setRevisionDialog({ ...revisionDialog, open: false })}
      PaperProps={{
        className: 'admin-dialog'
      }}
    >
      <div className="dialog-header">
        <Typography variant="h6" className="dialog-title">
          <Warning /> Request Revision for Order #{revisionDialog.orderId}
        </Typography>
        <IconButton 
          className="dialog-close"
          onClick={() => setRevisionDialog({ ...revisionDialog, open: false })}
        >
          <Cancel />
        </IconButton>
      </div>
      
      <DialogContent>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          {revisionDialog.orderTitle}
        </Typography>
        
        <div className="form-group">
          <Typography className="form-label" sx={{ mb: 1 }}>
            Revision Instructions/Notes:
          </Typography>
          <TextField
            multiline
            rows={4}
            fullWidth
            placeholder="Explain what needs to be revised. This will be sent to the writer."
            value={revisionDialog.revisionNotes}
            onChange={(e) => setRevisionDialog({ ...revisionDialog, revisionNotes: e.target.value })}
            className="text-field"
          />
        </div>
        
        <Alert severity="info" className="alert alert-info">
          <Typography variant="body2">
            <strong>Note:</strong> The order status will change to "REVISION" and will be sent back to the writer for revisions.
          </Typography>
        </Alert>
      </DialogContent>
      
      <div className="dialog-footer">
        <Button 
          className="btn btn-outline"
          onClick={() => setRevisionDialog({ ...revisionDialog, open: false })}
        >
          Cancel
        </Button>
        <Button 
          className="btn btn-warning"
          onClick={handleRequestRevision}
        >
          Request Revision
        </Button>
      </div>
    </Dialog>
  );

  // Snackbar component
  const renderSnackbar = () => (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={6000}
      onClose={closeSnackbar}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <Alert 
        onClose={closeSnackbar} 
        severity={snackbar.severity}
        sx={{ width: '100%' }}
      >
        {snackbar.message}
      </Alert>
    </Snackbar>
  );

  if (loading) {
    return (
      <div className="admin-dashboard-container">
        <Container sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <Typography variant="h6" className="loading-text">
              Loading Dashboard...
            </Typography>
          </div>
        </Container>
      </div>
    );
  }

  return (
    <div className="admin-dashboard-container">
      <Container maxWidth="xl" sx={{ py: 4 }}>
        {/* Header */}
        <Paper className="admin-header">
          <Typography variant="h4" className="admin-title">
            <Dashboard /> Admin Dashboard
          </Typography>
          <Typography variant="subtitle1" className="admin-subtitle">
            Manage orders, writers, and system operations
          </Typography>
        </Paper>
        
        {/* Main Tabs */}
        <Paper className="admin-tabs-container">
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            className="admin-tabs"
            variant="scrollable"
            scrollButtons="auto"
          >
            {tabs.map((tab, index) => (
              <Tab
                key={index}
                icon={tab.icon}
                iconPosition="start"
                label={tab.label}
                className={`admin-tab ${activeTab === index ? 'active' : ''}`}
              />
            ))}
          </Tabs>
          
          {/* Content Panel */}
          <Box className="admin-content-panel">
            {activeTab === 0 && renderDashboard()}
            {activeTab === 1 && renderManageOrders()}
            {activeTab === 2 && renderManageWritersAndPayments()}
            {activeTab === 3 && renderMessages()}
            {activeTab === 4 && renderManageBlogs()}
            {activeTab === 5 && renderPricingManagement()}
            {activeTab === 6 && renderSamplesManagement()}
          </Box>
        </Paper>
      </Container>
      
      {/* Dialogs */}
      {renderAssignDialog()}
      {renderOrderDetailsDialog()}
      {renderRevisionDialog()}
      
      {/* Snackbar for notifications */}
      {renderSnackbar()}
    </div>
  );
};

export default AdminDashboard;
